module.exports = __webpack_public_path__ + "images/thumbs-up-outline73abc8907752eee9395ba660b97f3ecc.svg";